module.exports = __webpack_public_path__ + "static/media/AI-屏幕-新.7ca9a898.jpg";